<template>
  <icon-base
    icon-name="OrcID ID"
    :icon-color="iconColor"
    :width="width"
    :height="height">
    <g
      transform="matrix(1.8417266,0,0,1.8338109,-126.15827,-85.638971)">
      <path d="M 86.3,186.2 H 70.9 V 79.1 h 15.4 v 48.4 z" />
      <path
        d="m 108.9,79.1 h 41.6 c 39.6,0 57,28.3 57,53.6 0,27.5 -21.5,53.6 -56.8,53.6 h -41.8 z m 15.4,93.3 h 24.5 c 34.9,0 42.9,-26.5 42.9,-39.7 C 191.7,111.2 178,93 148,93 h -23.7 z" />
      <path
        d="m 88.7,56.8 c 0,5.5 -4.5,10.1 -10.1,10.1 -5.6,0 -10.1,-4.6 -10.1,-10.1 0,-5.6 4.5,-10.1 10.1,-10.1 5.6,0 10.1,4.6 10.1,10.1 z" />
    </g>
  </icon-base>
</template>

<script>
import IconBase from '../IconBase'

export default {
  name: 'icon-orcid-id',

  components: {
    'icon-base': IconBase
  },

  props: {
    iconColor: {
      type: String,
      default: 'currentColor'
    },
    width: {
      type: [Number, String],
      default: 256
    },
    height: {
      type: [Number, String],
      default: 256
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/icons/typography/IconOrcidId.vue